export default __webpack_public_path__ + "static/media/coca-cola.b9d90c1d.png";